import { Trash2 } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Textarea } from '@/components/ui/textarea'
import { cn, titleCase } from '@/lib/utils'
import type { DraftAssertion } from '../../hooks/useSaveAssertionsMutation'
import {
  ASSERTION_SEVERITIES,
  severitySegClassName,
} from './assertionPresentation'

type AssertionEditRowProps = {
  row: DraftAssertion
  index: number
  onChange: (index: number, patch: Partial<DraftAssertion>) => void
  onRemove: (index: number) => void
}

export function AssertionEditRow({
  row,
  index,
  onChange,
  onRemove,
}: AssertionEditRowProps) {
  return (
    <div className="flex flex-col gap-2 rounded-lg border border-(--neutral-ui-border) bg-gray-50 p-3">
      <div className="flex items-start gap-2">
        <Input
          value={row.name}
          onChange={(e) => onChange(index, { name: e.target.value })}
          placeholder="Assertion name"
          aria-label="Assertion name"
        />
        <Button
          type="button"
          variant="ghost"
          size="icon-sm"
          aria-label="Delete assertion"
          onClick={() => onRemove(index)}>
          <Trash2 className="size-4" />
        </Button>
      </div>
      <Textarea
        value={row.criteria}
        onChange={(e) => onChange(index, { criteria: e.target.value })}
        placeholder="What the judge should check for"
        rows={2}
        aria-label="Assertion criteria"
      />
      <div className="flex flex-wrap items-center gap-2">
        <span className="mr-1 text-[11px] font-semibold tracking-wide text-neutral-low-contrast uppercase">
          Severity
        </span>
        {ASSERTION_SEVERITIES.map((severity) => {
          const active = row.severity === severity
          return (
            <button
              key={severity}
              type="button"
              aria-pressed={active}
              className={cn(
                'h-8 cursor-pointer rounded-lg border px-3 text-xs font-medium',
                severitySegClassName(severity, active)
              )}
              onClick={() => onChange(index, { severity })}>
              {titleCase(severity)}
            </button>
          )
        })}
      </div>
    </div>
  )
}
